import React from 'react';
import {
  useRecordContext,
  useStore,
} from 'react-admin';

import AiAnalysisResult from './AiAnalysisResult';
import AiAnalysisEditResult from './AiAnalysisEditResult';
import AiAnalysisLoading from './AiAnalysisLoading';
import AiAnalysisNoData from './AiAnalysisNoData';
import { ICaseAnalysis } from '../../../../utilities/schemas/caseAnalysis';
import agentModes, { AgentMode } from '../../../../constants/agentModes';
import aiGenerationStatuses from '../../../../constants/aiGenerationStatuses';

const AiAnalysisDisplay = () => {
  const analysisData = useRecordContext<ICaseAnalysis>();
  const [agentMode] = useStore<AgentMode>('agentMode', agentModes.FETCHING);

  if (!analysisData) return <AiAnalysisNoData />;

  if (agentMode === agentModes.LOADING) {
    return (
      <AiAnalysisLoading
        isLoading={analysisData.status === aiGenerationStatuses.CREATED}
      />
    );
  }

  if (agentMode === agentModes.EDIT) {
    return <AiAnalysisEditResult />;
  }

  return <AiAnalysisResult />;
};

export default AiAnalysisDisplay;
